// import * as Yup from "yup";
// import { useFormik } from "formik";
// import { usePostDataMutation } from "@/core/api/api";
// import { endpoints } from "@/core/api/endpoints";
// import { ApiResponse } from "@/interface/error.interface";
// import {
//   showErrorMessage,
//   showSuccessMessage,
// } from "@/utils/toastMessage/toast.message";
// import handleErrors from "@/utils/handleError";

// interface RatingValues {
//   package_id: string;
//   user_id?: string;
//   rating: number;
//   comment?: string;
// }

// export const useCreateRating = () => {
//       const [rating, setRating] = useState(0);

//   const [postRating, { isLoading }] = usePostDataMutation();

//   const formik = useFormik<RatingValues>({
//     initialValues: {
//       package_id: "",
//       user_id: "",
//       rating: 0,
//       comment: "",
//     },
//     validationSchema: Yup.object({
//       package_id: Yup.string().required("Package ID is required"),
//       user_id: Yup.string(),
//       rating: Yup.number()
//         .min(1, "Rating must be at least 1")
//         .max(5, "Rating cannot be more than 5")
//         .required("Rating is required"),
//       comment: Yup.string(),
//     }),
//     onSubmit: async (values, { resetForm }) => {
//       try {
//         const response = await postRating({
//           url: `${endpoints.ADDRATING}`,
//           data: values,
//         });
//         if (response?.error) {
//           handleErrors(response as ApiResponse, formik.setErrors);
//           showErrorMessage("error");

//           return;
//         }

//         if (response.data) {
//           showSuccessMessage(response.data.message);
//           resetForm();
//         }
//       } catch (error) {
//         console.error(error);
//       }
//     },
//   });

//   return {
//     formik,
//     isLoading,
//   };
// };
import { usePostDataMutation } from "@/core/api/api";
import { endpoints } from "@/core/api/endpoints";
import { ApiResponse } from "@/interface/error.interface";
import {
  showErrorMessage,
  showSuccessMessage,
} from "@/utils/toastMessage/toast.message";
import { useFormik } from "formik";
import { useSession } from "next-auth/react";
import { useState } from "react";
import * as Yup from "yup";

interface UseAddReviewRatingProps {
  id: string;
}

export const useAddRatingComment = ({ id }: UseAddReviewRatingProps) => {
  const [rating, setRating] = useState(0);
  const [postReview] = usePostDataMutation();

  const { data } = useSession();
  const userId = data?.user?.id || "";
  const formik = useFormik({
    initialValues: {
      comment: "",
    },
    validationSchema: Yup.object({
      comment: Yup.string().required("Review is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (rating === 0) {
        showErrorMessage("Please select a rating.");
        return;
      }

      const resData = {
        rating,
        comment: values.comment,
        package_id: id,
        user_id: userId,
      };

      try {
        const res = (await postReview({
          url: endpoints.ADDRATING,
          data: resData,
          //   invalidateTag: TAGS.REVIEW,
        })) as ApiResponse;

        if (res?.error) {
          showErrorMessage(
            res.error?.data?.message || "Failed to submit review"
          );
          return;
        }

        if (res?.data) {
          showSuccessMessage(
            res.data?.message || "Review submitted successfully"
          );
          resetForm();
          setRating(0);
        }
      } catch (err) {
        console.error(err);
      }
    },
  });

  return {
    rating,
    setRating,
    formik,
  };
};
